import React from 'react';

import { MainBlockProps, ColumnPosition } from './MainBlock';

function getColumnPosition(position?: ColumnPosition): ColumnPosition {
  return position || ColumnPosition.RIGHT;
}

export default function ShadcnMainBlock(props: MainBlockProps) {
  const columnPosition = getColumnPosition(props.columnPosition);
  const hasColumn = !!props.columnContent;

  const columnElement = hasColumn ? (
    <div
      className="w-80 shrink-0"
      data-testid="mainblock-column"
    >
      {props.columnContent}
    </div>
  ) : null;

  return (
    <div className="h-full">
      {(props.headerRight || props.title) && (
        <div className="mb-6" data-testid="mainblock-header">
          <div className="flex items-start justify-between gap-4">
            <div>
              <h1 className="!mb-0">{props.title}</h1>
              {props.titleLine2 && (
                <div className="text-app-body text-gray-500 mt-1">
                  {props.titleLine2}
                </div>
              )}
            </div>
            {props.headerRight && (
              <div
                className="flex items-center gap-2 shrink-0 flex-wrap justify-end"
                data-testid="mainblock-header-right"
              >
                {props.headerRight}
              </div>
            )}
          </div>
        </div>
      )}
      <div className="flex flex-1 gap-6">
        {columnElement && columnPosition === ColumnPosition.LEFT ? columnElement : null}
        <div className="flex-1 min-w-0 pb-16">
          {props.children}
        </div>
        {columnElement && columnPosition === ColumnPosition.RIGHT ? columnElement : null}
      </div>
    </div>
  );
}
